import { escapeAttr, escapeHtml, linkAttrs } from "@emkit/builder-core";
export const NAV_MENU_DEFAULTS = {
    brand: "EmKit",
    brandHref: "/",
    logoUrl: "",
    items: [
        { id: "n1", label: "Home", href: "/" },
        {
            id: "n2",
            label: "Product",
            href: "/product",
            children: [
                { id: "n2a", label: "EmBuilder", href: "/product/embuilder" },
                { id: "n2b", label: "EmDash", href: "/product/emdash" },
            ],
        },
        { id: "n3", label: "Pricing", href: "/pricing" },
        { id: "n4", label: "Docs", href: "/docs" },
    ],
    cta: { label: "Sign in", href: "/login" },
    align: "end",
    sticky: false,
    background: "#ffffff",
    textColor: "#0f172a",
    accent: "#111827",
    bordered: true,
};
const ALIGN_MAP = { start: "flex-start", center: "center", end: "flex-end" };
export const navMenuWidget = {
    type: "nav-menu",
    defaultProps: NAV_MENU_DEFAULTS,
    renderHtml(props, ctx) {
        const items = props.items ?? [];
        const align = props.align ?? "end";
        const bg = props.background ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const accent = props.accent ?? "#111827";
        const sticky = props.sticky ?? false;
        const bordered = props.bordered ?? true;
        const gid = `nav-${Math.random().toString(36).slice(2, 8)}`;
        const logo = props.logoUrl
            ? `<img src="${escapeAttr(ctx.resolveAssetUrl?.(props.logoUrl) ?? props.logoUrl)}" alt="${escapeAttr(props.brand ?? "")}" style="height:28px;width:auto;display:block">`
            : "";
        const brandHref = props.brandHref ?? "/";
        const brand = props.brand
            ? `<a href="${escapeAttr(brandHref)}"${linkAttrs(brandHref)} style="display:inline-flex;align-items:center;gap:8px;text-decoration:none;color:${text};font-weight:600;font-size:17px">${logo}${escapeHtml(props.brand)}</a>`
            : logo
                ? `<a href="${escapeAttr(brandHref)}"${linkAttrs(brandHref)} style="display:inline-flex;text-decoration:none">${logo}</a>`
                : "";
        const itemLink = (href, label) => `<a href="${escapeAttr(href)}"${linkAttrs(href)} style="display:inline-flex;align-items:center;padding:8px 12px;color:${text};text-decoration:none;font-size:15px;font-weight:500;border-radius:6px;transition:background 0.15s">${escapeHtml(label)}</a>`;
        const navItems = items
            .map((it) => {
            if (it.children && it.children.length > 0) {
                const children = it.children
                    .map((c) => `<a href="${escapeAttr(c.href)}"${linkAttrs(c.href)} style="display:block;padding:8px 14px;color:${text};text-decoration:none;font-size:14px;border-radius:4px;transition:background 0.1s">${escapeHtml(c.label)}</a>`)
                    .join("");
                return `<li class="${gid}-item" style="position:relative;list-style:none">${itemLink(it.href, `${it.label} ▾`)}<div class="${gid}-menu" style="position:absolute;top:100%;left:0;margin-top:4px;min-width:180px;background:${bg};border:1px solid rgba(0,0,0,0.08);border-radius:8px;padding:6px;box-shadow:0 8px 24px rgba(0,0,0,0.08);display:none;z-index:50">${children}</div></li>`;
            }
            return `<li style="list-style:none">${itemLink(it.href, it.label)}</li>`;
        })
            .join("");
        const cta = props.cta
            ? `<a href="${escapeAttr(props.cta.href)}"${linkAttrs(props.cta.href)} style="display:inline-flex;align-items:center;padding:8px 16px;background:${accent};color:#fff;text-decoration:none;font-size:14px;font-weight:500;border-radius:6px">${escapeHtml(props.cta.label)}</a>`
            : "";
        const styles = `<style>.${gid}-item:hover .${gid}-menu,.${gid}-item:focus-within .${gid}-menu{display:block}.${gid} a:hover{background:rgba(0,0,0,0.04)}</style>`;
        const wrapStyle = [
            "display:flex",
            "align-items:center",
            "gap:24px",
            `padding:12px 20px`,
            `background:${bg}`,
            bordered ? "border-bottom:1px solid rgba(0,0,0,0.08)" : "",
            sticky ? "position:sticky;top:0;z-index:40" : "",
            "font-family:inherit",
        ]
            .filter(Boolean)
            .join(";");
        return `<nav class="emk-nav ${gid}" style="${wrapStyle}">${styles}${brand}<ul style="display:flex;flex:1;list-style:none;padding:0;margin:0;gap:4px;justify-content:${ALIGN_MAP[align]}">${navItems}</ul>${cta}</nav>`;
    },
};
//# sourceMappingURL=nav-menu.js.map